module.exports = __webpack_public_path__ + "static/images/b8d972ff82dd6c50039aded44f508c22.webp";